import { modules } from "./modules";
export { modules };

export default {
  namespaced: true,
  modules
};
